import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtTL, fmtNum } from "@/lib/utils";

export function DiffBadge({ pct, testid }) {
  if (pct == null) return <span className="text-xs text-muted-foreground" data-testid={testid}>Karşılaştırma yok</span>;
  const cls = pct > 10 ? "bg-rose-500/15 text-rose-700 dark:text-rose-400" : pct > 1 ? "bg-amber-500/15 text-amber-700 dark:text-amber-400"
    : pct < -1 ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400" : "bg-slate-500/15 text-slate-700 dark:text-slate-300";
  return <span className={`inline-block text-xs font-semibold font-mono-nums px-1.5 py-0.5 rounded ${cls}`} data-testid={testid}>{pct > 0 ? "+" : pct < 0 ? "-" : ""}%{fmtNum(Math.abs(pct))}</span>;
}

export default function FirmScorecard({ firmId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); api.get(`/scorecards/${firmId}`).then(r => setData(r.data)).catch(() => setErr(true)); }, [firmId]);
  if (err) return <div className="p-6 text-sm text-rose-600">Fiyat karnesi yüklenemedi.</div>;
  if (!data) return <div className="p-6 text-sm text-muted-foreground">Yükleniyor...</div>;
  const s = data.summary;

  return (
    <div data-testid="firm-scorecard">
      <p className="text-xs text-muted-foreground mb-3">Firmanın ağırlıklı birim fiyatı, aynı yıl içinde aynı (veya eşlenmiş) kalemi yapan diğer firmaların ağırlıklı ortalamasıyla karşılaştırılır.</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <Kpi label="Genel Fiyat Farkı" value={<DiffBadge pct={s.weighted_diff_pct} testid="scorecard-weighted" />} />
        <Kpi label="Karşılaştırılan Kalem" value={`${s.compared_items} (tutarın %${fmtNum(s.coverage_pct)}'i)`} />
        <Kpi label="Ortalamadan Pahalı" value={<span className="text-rose-600">{s.above}</span>} />
        <Kpi label="Ortalamadan Ucuz" value={<span className="text-emerald-600">{s.below}</span>} />
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-muted-foreground py-4">Bu firmanın kalemleri aynı yıl başka firmalarca yapılmamış. Kalem Eşleme sayfasında farklı yazımları eşleyerek karşılaştırmayı artırabilirsiniz.</p>
      ) : (
        <Table>
          <TableHeader><TableRow><TableHead>Kalem</TableHead><TableHead>Yıl</TableHead><TableHead className="text-right">Firma Fiyatı</TableHead>
            <TableHead className="text-right">Diğerleri Ort.</TableHead><TableHead className="text-right">Fark</TableHead><TableHead className="text-right">Tutar</TableHead></TableRow></TableHeader>
          <TableBody>{data.items.map((i, k) => (
            <TableRow key={k} data-testid="scorecard-row">
              <TableCell className="text-sm">{i.label}<div className="text-[11px] text-muted-foreground">{i.unit} · {i.other_firms} diğer firma</div></TableCell>
              <TableCell className="font-mono-nums">{i.year}</TableCell>
              <TableCell className="text-right font-mono-nums font-semibold">{fmtTL(i.price)}</TableCell>
              <TableCell className="text-right font-mono-nums">{fmtTL(i.others_avg)}</TableCell>
              <TableCell className="text-right"><DiffBadge pct={i.diff_pct} /></TableCell>
              <TableCell className="text-right font-mono-nums text-xs">{fmtTL(i.amount)}</TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      )}
    </div>
  );
}

function Kpi({ label, value }) {
  return (
    <div className="rounded-lg border border-border bg-muted/30 p-3">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className="font-bold mt-1 text-sm">{value}</div>
    </div>
  );
}
